const SectionQuiz = Class(
	/**
	 * @lends {SectionQuiz#}
	 */
	{
		__NAME: 'SectionQuiz',

		bodyClass: 'small-nav grey',
		name: 'quiz',

		route: function(){
			if( D.LANG !== 'lv' ){
				document.location.href = D.url(this.url.href, 'lv');
				return;
			}
			let part = this.url.shift();
			switch(part){
				case 'character':
					return new SectionQuiz.Test();
			}
		},

		draw: function(){
			mkE({
				tag: 'div',
				id: 'quiz-landing',
				els: [
					{
						tag: 'div',
						className: 'quiz-landing-container',
						els: [
							{
								tag: 'div',
								className: 'quiz-landing-header',
								els: [
									{
										tag: 'h1',
										text: D.Lang.get('quiz.landing.title')
									}
								]
							},
							{
								tag: 'div',
								className: 'quiz-landing-content',
								els: [
									{
										tag: 'p',
										text: D.Lang.get('quiz.landing.text')
									},
									{
										tag: 'p',
										text: D.Lang.get('quiz.landing.caption')
									},
									{
										tag: 'a',
										className: 'button button-pink button-large',
										href: D.url('quiz/character'),
										text: D.Lang.get('quiz.landing.button')
									}
								]
							}
						]
					}
				]
			}).append(this.layout.ct());
			this.ready();
		}
	},
	Section
);

SectionQuiz.Test = Class(
	/**
	 * @lends {SectionQuiz.Test#}
	 */
	{
		__NAME: 'SectionQuiz.Test',

		bodyClass: 'small-nav grey hide-tablet-footer full-container no-mobile-sticky',
		name: 'character',

		_steps: [],
		_questions: [],

		route: function(){
			let part = this.url.shift();
			if( part && in_array(part, ['muzikis', 'teicamnieks', 'menedzeris', 'krumu-direktors', 'benzintanka-gurmans']) ){
				return new SectionQuiz.Character();
			}
		},

		draw: function(){
			this._containerNode = mkE({
				tag: 'div',
				id: 'quiz-test'
			}).append(this.layout.ct());
			this._initQuestions();
			this._wizard = new T.Wizard({
				getSteps: this._getSteps,
				returnUrl: D.url('quiz'),
				onStepChange: this._onStepChange
			}).append(this._containerNode);
			this.ready();
		},

		onShow: function(){
			this._scrollQuestion();
		},

		_onStepChange: function(){
			this._scrollQuestion();
		},

		_scrollQuestion: function(){
			let top = findPosY(this._containerNode);
			$('html, body').scrollTop(top);
		},

		_getSteps: function(){
			return this._steps;
		},

		_initQuestions: function(){
			let questionData = [
				{
					question: 'Kas ir pirmā lieta, ko Tu dari iekāpjot mašīnā?',
					answers: [
						{
							value: '2-2',
							caption: 'Piesprādzējos'
						},
						{
							value: '1-2',
							caption: 'Ieslēdzu mīļāko dziesmu'
						},
						{
							value: '3-2',
							caption: 'Uzlieku lādēties telefonu'
						},
						{
							value: '4-2',
							caption: 'Atveru navigāciju'
						},
						{
							value: '5-2',
							caption: 'Atrodu kaut ko ēdamu'
						},
						{
							value: 0,
							caption: 'Neko - sāku braukt'
						}
					]
				},
				{
					question: 'Dodoties izbraucienā, vienmēr līdzi ņemu:',
					answers: [
						{
							value: '5-2',
							caption: 'Našķus'
						},
						{
							value: '1-2',
							caption: 'Savu mūziku'
						},
						{
							value: '4-2',
							caption: 'Navigāciju'
						},
						{
							value: '2-2',
							caption: 'Grāmatu'
						},
						{
							value: 0,
							caption: 'Visu iedzīvi'
						},
						{
							value: '3-2',
							caption: 'Maku'
						}
					]
				},
				{
					question: 'Iemesls, kāpēc es apstātos brauciena laikā:',
					answers: [
						{
							value: 1,
							caption: 'Pazuda signāls'
						},
						{
							value: 5,
							caption: 'Beidzās našķi'
						},
						{
							value: 3,
							caption: 'Apstādināja policija'
						},
						{
							value: 4,
							caption: 'Savajadzējās krūmiņus'
						},
						{
							value: 2,
							caption: 'Jāpapildina degviela'
						},
						{
							value: 0,
							caption: 'Ieraudzīju foršu vietu'
						}
					]
				},
				{
					question: 'Ja visu brauciena laiku būtu spiests klausīties tikai vienu dziesmu, tā būtu:',
					answers: [
						{
							value: 2,
							caption: 'Jebkas no “Prāta Vētra”'
						},
						{
							value: 4,
							caption: 'Livin\' on a prayer'
						},
						{
							value: 3,
							caption: 'Africa / Toto'
						},
						{
							value: 1,
							caption: 'Another one bites the dust'
						},
						{
							value: 0,
							caption: 'Wannabe / Spice Girls'
						},
						{
							value: 5,
							caption: 'Kaija / Bruģis'
						}
					]
				},
				{
					question: 'Kurš vārds tevi raksturo vislabāk?',
					answers: [
						{
							value: 3,
							caption: 'Mērķtiecīgs'
						},
						{
							value: 1,
							caption: 'Jautrs'
						},
						{
							value: 2,
							caption: 'Zinošs'
						},
						{
							value: 4,
							caption: 'Nepacietīgs'
						},
						{
							value: 5,
							caption: 'Enerģisks'
						},
						{
							value: 0,
							caption: 'Nopietns'
						}
					]
				},
				{
					question: 'Kas ir Tava visbiežāk apmeklētā vieta pasākumā?',
					answers: [
						{
							value: 3,
							caption: 'Backstage'
						},
						{
							value: 1,
							caption: 'Skatuve, DJ pults'
						},
						{
							value: 2,
							caption: 'Tur, kur redzama pasākuma programma'
						},
						{
							value: 4,
							caption: 'Labierīcības'
						},
						{
							value: 5,
							caption: 'Bārs'
						},
						{
							value: 0,
							caption: 'Kāds klusāks stūrītis'
						}
					]
				}
			];
			for( let i = 0, l = questionData.length; i < l; i++ ){
				let question = new SectionQuiz.Test.Question(questionData[i], i === 0, i === l - 1, this._save);
				this._questions.push(question);
				this._steps.push(question.getStep());
			}
		},

		_save: function(){
			let map = {
				1: 'muzikis',
				2: 'teicamnieks',
				3: 'menedzeris',
				4: 'krumu-direktors',
				5: 'benzintanka-gurmans'
			};
			let results = {};
			for( let i = 0, l = this._questions.length; i < l; i++ ){
				let answerValue = String(this._questions[i]._value).split('-');
				let answer = Number(answerValue[0]);
				let count = Number(answerValue[1] || 1);
				if( answer === 0 ){
					continue;
				}
				if( results[answer] ){
					results[answer].count += count;
				}else{
					results[answer] = {
						count: count,
						index: i,
						answer: answer
					};
				}
			}
			if( empty(results) ){
				Section.navigate(D.url('quiz/character/' + map[5]));
				return;
			}
			let topAnswers = [];
			let topAnswerCount = null;
			for( let answer in results ){
				if( !results.hasOwnProperty(answer) ){
					continue;
				}
				let count = results[answer].count;
				if( topAnswerCount === null || topAnswerCount < count ){
					topAnswers = [results[answer]];
					topAnswerCount = count;
				}else if( topAnswerCount === count ){
					topAnswers.push(results[answer]);
				}
			}
			function compare(a,b) {
				if (a.index < b.index) {
					return -1;
				}
				if (a.index > b.index) {
					return 1;
				}
				return 0;
			}
			topAnswers.sort(compare);
			let topAnswer = reset(topAnswers);
			Section.navigate(D.url('quiz/character/' + map[topAnswer.answer]), {
				popState: true
			});
		}
	},
	Section
);

/**
 * @class {SectionQuiz.Test.Question}
 * @param {Object} par
 * @param {Boolean} isFirst
 * @param {Boolean} isLast
 * @param {Function} process
 */
SectionQuiz.Test.Question = Class(
	/**
	 * @lends {SectionQuiz.Test.Question#}
	 */
	{
		__NAME: 'SectionQuiz.Test.Question',
		_answers: [],
		_value: 0,

		/**
		 * @param {Object} par
		 * @param {Boolean} isFirst
		 * @param {Boolean} isLast
		 * @param {Function} process
		 * @constructs
		 */
		__construct: function(par, isFirst, isLast, process){
			this.par = par;
			this.isFirst = isFirst;
			this.isLast = isLast;
			this._process = process;

			this.node = mkE({
				tag: 'div',
				className: 'quiz-question',
				els: [
					{
						tag: 'h2',
						text: par.question
					},
					this._answersNode = mkE({
						tag: 'div',
						className: 'quiz-answers'
					})
				]
			});

			for( let i = 0, l = par.answers.length; i < l; i++ ){
				let answer = mkE({
					tag: 'div',
					className: 'quiz-answer',
					text: par.answers[i].caption,
					onclick: D.closure(this, this._select, i)
				}).append(this._answersNode);
				this._answers.push(answer);
			}
		},

		_select: function(index) {
			for( let i = 0, l = this._answers.length; i < l; i++ ){
				if( i === index ){
					addClassName(this._answers[i], 'selected');
				}else{
					removeClassName(this._answers[i], 'selected');
				}
			}
			this._value = this.par.answers[index].value;
			this.getStep().setCanContinue(true);
		},

		getStep: function(){
			if( this._step ){
				return this._step;
			}
			this._step = new T.Wizard.Step({
				getContent: this.node,
				canGoBack: this.isFirst,
				continueAction: this.isLast ? this._process : null
			});
			return this._step;
		}
	}
);

SectionQuiz.Character = Class(
	/**
	 * @lends {SectionQuiz.Character#}
	 */
	{
		__NAME: 'SectionQuiz.Character',

		bodyClass: 'small-nav grey',
		name: 'character-display',

		route: function(){
			this._character = this.url.before;
		},

		draw: function(){
			let text = '“' + D.Lang.get('quiz.results.' + this._character + '.title') + '”';
			let share = [];
			if( !this.url.get.is('share') ){
				text = D.Lang.get('quiz.results.youAre') + ' ' + text;
				share = [
					{
						tag: 'h2',
						text: D.Lang.get('quiz.results.share')
					},
					this._shareButtons = mkE({
						tag: 'div',
						className: 'quiz-character-buttons'
					})
				];
				this._drawShareButtons();
			}
			this._containerNode = mkE({
				tag: 'div',
				id: 'quiz-character',
				className: 'quiz-character-' +  this._character,
				els: [
					{
						tag: 'div',
						className: 'quiz-character-top',
						els: [
							{
								tag: 'div',
								className: 'quiz-character-image',
								els: [
									{
										tag: 'h1',
										text: text
									},
									{
										tag: 'p',
										text: D.Lang.get('quiz.results.' + this._character + '.description')
									},
									{
										tag: 'div',
										className: 'quiz-again',
										els: [
											{
												tag: 'a',
												href: D.url('quiz/character'),
												text: D.Lang.get(this.url.get.is('share') ? 'quiz.results.firstTime' : 'quiz.results.again')
											}
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'quiz-character-share',
						els: share
					}
				]
			}).append(this.layout.ct());
			this.ready();
		},

		_drawShareButtons: function(){
			mkE({
				tag: 'a',
				className: 'facebook',
				href: this._getFacebookUrl(),
				target: '_blank',
				text: 'Facebook',
				onclick: this._openFacebook
			}).append(this._shareButtons);

			mkE({
				tag: 'a',
				className: 'draugiem',
				href: this._getDraugiemUrl(),
				target: '_blank',
				text: 'Draugiem',
				onclick: this._openDraugiem
			}).append(this._shareButtons);

			mkE({
				tag: 'a',
				className: 'twitter',
				href: this._getTwitterUrl(),
				target: '_blank',
				text: 'Twitter',
				onclick: this._openTwitter
			}).append(this._shareButtons);
		},

		_getUrl: function(){
			return D.url('quiz/character/' + this._character + '?share', null, true);
		},

		_getText: function(){
			return D.Lang.get('quiz.results.iAm') + ' “' + D.Lang.get('quiz.results.' + this._character + '.title') + '” - ' + D.Lang.get('quiz.results.discover');
		},

		_getFacebookUrl: function(){
			let get = new Get('https://www.facebook.com/dialog/share');
			get.add('app_id', D.FB_APP_ID);
			get.add('href', this._getUrl());
			get.add('quote', this._getText());
			get.add('hashtag', '#roadgames #rgms');
			return get.toUrl();
		},

		_openFacebook: function(){
			let url = this._getFacebookUrl();
			let width = window.innerWidth;
			let height = window.innerHeight;
			let left = Math.round(width / 2 - 335);
			let top = 0;
			if (height > 620) {
				top = Math.round(height / 2 - 310);
			}
			let win = window.open(url, null, 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=670,height=620,left=' + left + ',top=' + top);
			win.opener = null;
			return false;
		},

		_getDraugiemUrl: function(){
			let get = new Get('https://www.draugiem.lv/say/ext/add.php');
			get.add('url', this._getUrl());
			get.add('title', 'Roadgames');
			get.add('text', this._getText());
			return get.toUrl();
		},

		_openDraugiem: function(){
			let url = this._getDraugiemUrl();
			let width = window.innerWidth;
			let height = window.innerHeight;
			let left = Math.round(width / 2 - 275);
			let top = 0;
			if (height > 380) {
				top = Math.round(height / 2 - 190);
			}
			let win = window.open(url, null, 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=380,left=' + left + ',top=' + top);
			win.opener = null;
			return false;
		},

		_getTwitterUrl: function(){
			let get = new Get('https://twitter.com/intent/tweet');
			get.add('url', this._getUrl());
			get.add('text', this._getText());
			get.add('hashtags', 'roadgames');
			return get.toUrl();
		},

		_openTwitter: function(){
			let url = this._getTwitterUrl();
			let width = window.innerWidth;
			let height = window.innerHeight;
			let left = Math.round(width / 2 - 275);
			let top = 0;
			if (height > 420) {
				top = Math.round(height / 2 - 210);
			}
			let win = window.open(url, null, 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,left=' + left + ',top=' + top);
			win.opener = null;
			return false;
		}
	},
	Section
);